import { z } from "zod";
import { syncOperationSchema } from "./operations";

/**
 * Sync protocol between devices and the account's Vault. The server is an append-only log of
 * operations; every device merges them deterministically (field-level last-writer-wins), so the
 * server never needs to understand entities.
 */
export const MAX_PUSH_OPERATIONS = 500;
export const MAX_PULL_OPERATIONS = 1000;

export const pushRequestSchema = z.object({
  deviceId: z.string().min(1).max(128),
  operations: z.array(syncOperationSchema).max(MAX_PUSH_OPERATIONS)
});
export type PushRequest = z.infer<typeof pushRequestSchema>;

export const pushResponseSchema = z.object({
  /** Operation ids now stored on the server (including ones it already had). */
  accepted: z.array(z.string()),
  /** Highest sequence in the log after this push. */
  latest: z.number().int().nonnegative()
});
export type PushResponse = z.infer<typeof pushResponseSchema>;

export const pullResponseSchema = z.object({
  operations: z.array(syncOperationSchema),
  /** Pass as `after` on the next pull. */
  cursor: z.number().int().nonnegative(),
  hasMore: z.boolean()
});
export type PullResponse = z.infer<typeof pullResponseSchema>;

export const apiErrorSchema = z.object({
  error: z.object({ code: z.string(), message: z.string() })
});
export type ApiError = z.infer<typeof apiErrorSchema>;
